<template>
  <div>
    <v-card
      class="mx-auto my-5 py-5 px-2 p-sortingItem_card mr-2 ml-2 p-sortingItem__handle"
      elevation="24"
    >
      <div class="p-sortingItem__combinedBlock">
        <div class="d-flex justify-end mb-3">
          <v-btn outlined color="red" elevation="0" @click="cancel">
            グループ解除
          </v-btn>
        </div>
        <div v-for="item in items" :key="item.uuid" class="mb-3">
          <ItemPreview :item="item" />
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import ItemPreview from '../ItemPreview'

export default {
  name: 'CombinedSortItems',
  components: { ItemPreview },
  props: {
    items: {
      required: true,
      type: Array
    }
  },
  methods: {
    cancel () {
      this.$emit('combined-cancel')
    }
  }
}
</script>

<style scoped>
.p-sortingItem__handleIcon {
  position: absolute;
  height: 50px;
  width: 50px;
  z-index: 10;
  left: 10px;
  top: 10px;
}
</style>
